export const propertyContextQueryCache = {
  all() {
    return ["propertyContext"] as const
  },

  propertyContextLists() {
    return [...this.all(), "list"] as const
  },

  propertyContextList(orgId: string) {
    return [...this.propertyContextLists(), orgId] as const
  },
}
